import { resolveEnabledStepIds } from './resolveRequestFormSteps';
import { getRequestFormStepCatalogEntry } from '../config/requestFormStepRegistry';
import {
  OpportunityInformation,
  SiteInformation,
  FacilityPower,
  LargeUps,
  PowerDistribution,
  RackPower,
  SmallUps,
  Cooling,
  LiquidCooling,
  SupportingDocuments,
  Summary,
} from '../request/steps';

import type { ComponentType } from 'react';

/** Props vary per step; callers pass compatible props from CreateRequest / RequestDetail. */
export type FormStepComponent = ComponentType<Record<string, unknown>>;

export interface FormStepEntry {
  id: string;
  title: string;
  component: FormStepComponent;
}

const STEP_COMPONENTS: Record<string, FormStepComponent> = {
  opportunity: OpportunityInformation,
  'site-information': SiteInformation,
  'facility-power': FacilityPower,
  'large-ups': LargeUps,
  'power-distribution': PowerDistribution,
  'rack-power': RackPower,
  'small-ups': SmallUps,
  'cooling-readiness': Cooling,
  'liquid-cooling': LiquidCooling,
  documents: SupportingDocuments,
  summary: Summary,
};

function buildStepsFromEnabledIds(
  storedEnabledStepIds?: string[] | null,
): FormStepEntry[] {
  return resolveEnabledStepIds(storedEnabledStepIds)
    .map(id => {
      const component = STEP_COMPONENTS[id];
      if (!component) {
        return null;
      }
      const catalog = getRequestFormStepCatalogEntry(id);
      return {
        id,
        title: catalog?.title ?? id,
        component,
      };
    })
    .filter((entry): entry is FormStepEntry => entry != null);
}

/**
 * Step list for **new** requests (`CreateRequest`).
 */
export function buildRequestFormSteps(
  storedEnabledStepIds?: string[] | null,
): FormStepEntry[] {
  return buildStepsFromEnabledIds(storedEnabledStepIds);
}

/**
 * Step list for **view/edit** (`RequestDetail`).
 */
export function buildDetailFormSteps(
  storedEnabledStepIds?: string[] | null,
): FormStepEntry[] {
  return buildStepsFromEnabledIds(storedEnabledStepIds);
}
